import React from 'react'

import { Table } from '_zari/core'

import { TiposFirmaUsuario } from 'constants/index'

import * as Cells from './cells'

const FirmasTable = ({ listaFirmas, actualizarTabla, username }) => {
  return (
    <Table
      filas={listaFirmas}
      containerId='tabla-firmas'
      headRows={[{ label: 'TIPO FIRMA' }, { label: 'EXISTE FIRMA' }, { label: '' }]}
      rowTemplate={(row, k) => (
        <Table.Row key={k}>
          <Table.Cell>{row.tipoFirma ? TiposFirmaUsuario.__dictionary[row.tipoFirma].nombre : '--'} </Table.Cell>
          <Table.Cell>{row.tieneFirma ? 'SI' : 'NO'} </Table.Cell>
          <Cells.AccionesCell row={row} actualizarTabla={actualizarTabla} username={username} />
        </Table.Row>
      )}
    />
  )
}

export default React.memo(FirmasTable)
